import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import strings from 'strings';

import { useStyles } from './ProfileContentSkeleton.styled';

const COPIES = strings.inventoryProfiles.common;
const TAB_KEYS = [0, 1, 2, 3, 4, 5, 6];
const FIELD_KEYS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

export const ProfileContentSkeleton = () => {
  const classes = useStyles();

  return (
    <div
      role="progressbar"
      aria-label={COPIES.loadingProfile}
      aria-busy="true"
      className={classes.root}
    >
      <div className={classes.tabBar}>
        {TAB_KEYS.map(key => (
          <div key={key} className={classes.tab}>
            <Skeleton variant="text" className={classes.tabLabel} />
            {key === 0 && <span className={classes.activeIndicator} />}
          </div>
        ))}
      </div>

      <div className={classes.panel}>
        <Paper elevation={0} className={classes.card}>
          <Skeleton variant="text" className={classes.cardTitle} />
          <Grid container spacing={3}>
            {FIELD_KEYS.map(fieldKey => (
              <Grid key={fieldKey} item xs={12} sm={6} md={4}>
                <Skeleton variant="text" className={classes.fieldLabel} />
                <Skeleton variant="text" className={classes.fieldValue} />
              </Grid>
            ))}
          </Grid>
        </Paper>
      </div>
    </div>
  );
};
